import type { IconBaseProps } from "./Icon";

export default function DatabaseIcon({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Database</title>
      <path
        d="M12 9C16.4183 9 20 7.65685 20 6C20 4.34315 16.4183 3 12 3C7.58172 3 4 4.34315 4 6C4 7.65685 7.58172 9 12 9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.037 12C4.77 12.53 4 13.232 4 14C4 15.657 7.582 17 12 17C16.418 17 20 15.657 20 14C20 13.232 19.23 12.53 17.963 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 6V10C4 11.657 7.582 13 12 13C16.418 13 20 11.657 20 10V6M4 14V18C4 19.657 7.582 21 12 21C16.418 21 20 19.657 20 18V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
